import { HwTypeKey } from "@const/hwTypeKey.constants";
import { SkytapProps } from '@hostcfgs/skytap.data';
import { Card, Form, Input } from 'antd';
import React from 'react';
import { XmInputPassword } from 'src/component/inputPassword/XmInputPassword';
import { HostCfgCardProps } from '../../../../../data/props';
import { HostCfgItem } from '../../ConfigurationTypes';
import { AbstractPlatform } from '../AbstractPlatform';

export default class Skytap extends AbstractPlatform<SkytapProps> {

  protected installUrl = "https://xormon.com/install-cloud.php#Skytap";

  constructor(props) {
    super(props, HwTypeKey.SKYTAP, SkytapProps);
  }

  protected getFormItems(cfg: HostCfgItem<SkytapProps>): React.ReactNode {
    return <>
      {this.commonCard()}

      <Card {...HostCfgCardProps} title="API">
        <Form.Item label={"API Username"} name={this.path(t => t.data.username)} rules={[{ required: !this.isEdit(), message: 'Please input username!' }]} >
          <Input />
        </Form.Item>
        <Form.Item label={"API Key"} name={this.path(t => t.data.apiKey)} rules={[{ required: !this.isEdit(), message: 'Please input API Key!' }]} >
          <XmInputPassword />
        </Form.Item>
      </Card>
    </>;
  }
}
